<div *ngIf="contextId && dataUniverseId" class="container">

  <coreui-notification *ngIf="informationMessage" notificationStyle="information" [isPersistent]="true"
    [autoShow]="true">{{informationMessage}}</coreui-notification>

  <lib-count-details [activeDedupeType]="audienceForm?.get('dedupeType').value" [isDefinitionFlow]="true"
    [isEdit]="!disableRunCount" [audienceForm]="audienceForm"
    (handleInvalidDefinitionError)="triggerHandleInvalidDefinitionError()" [countsService]="countsService"
    [isSaveButtonDisabled]="!builderService.definitionHasAttribute$.value" [dedupeDisplayName]="getDedupeType()"
    (emitSubmitUpdateCount)="triggerSubmitUpdateCount($event)"
    (emitCancelUpdateCount)="cancelUpdateCount()"></lib-count-details>

  <lib-common-new-criteria-selection-flow-wrapper *ngIf="operators.length && criteria.nodeDetails" [criteria]="criteria"
    [operators]="operators" (attributeValueChanges)="onValueChanges($event)" [showCriteriaErrors]="showCriteriaErrors"
    [isEdit]="isEdit" [countInfo]="countInfo" [dataUniverseId]="dataUniverseId" [dedupeIdentityType]="activeDedupeType"
    [isProductTypeDcdp]="isProductTypeDcdp" [audiencesEnabled]="audiencesEnabled" [businessUnitId]="businessUnitId"
    [dedupeTdentityTypes]="dedupeTdentityTypes"></lib-common-new-criteria-selection-flow-wrapper>

</div>